import Vue from 'vue';
import { v4 as uuidv4 } from 'uuid';
import getOrderDetailDms from '../../modules/order/application/getOrderDetailDms';
import createApiOrderRepository from '../../modules/order/infrastructure/apiOrderRepository';
import isMainOrderClosed from '../../modules/order/application/isMainOrderClosed';
import STATE_STATUSES from '../state-statuses';

const repository = createApiOrderRepository();

export default {
  namespaced: true,

  state: {
    taxPercentage: 0,
    isMainOrderClosed: false,
    isMainOrderClosedStatus: STATE_STATUSES.UNINITIALIZED,
  },

  getters: {
    getTaxPercentage(state) {
      return state.taxPercentage;
    },

    getIsMainOrderClosed(state) {
      return state.isMainOrderClosed;
    },

    getIsMainOrderClosedStatus(state) {
      return state.isMainOrderClosedStatus;
    },
  },

  mutations: {
    SET_TAX_PERCENTAGE(state, payload) {
      Vue.set(state, 'taxPercentage', payload);
    },

    SET_IS_MAIN_ORDER_CLOSED(state, payload) {
      Vue.set(state, 'isMainOrderClosed', payload);
    },

    SET_IS_MAIN_ORDER_CLOSED_STATUS(state, payload) {
      Vue.set(state, 'isMainOrderClosedStatus', payload);
    },
  },

  actions: {
    // TODO: Find a way to omit this endpoint call,
    // since it's called only to retrieve the tax percentage.
    async getOrderDetailDms({ commit }) {
      try {
        const orders = Vue.prototype.$session.get('orders');
        if (orders.length > 0) {
          const ONE_HUNDRED_PERCENTAGE = 100;
          const params = {
            orderId: orders[orders.length - 1].orderIdDMS,
            transactionId: uuidv4(),
            dealerId: +Vue.prototype.$session.get('dealerId'),
          };
          const orderDMS = await getOrderDetailDms(repository, params);

          const taxePercentage = orderDMS.taxTypePercentage / ONE_HUNDRED_PERCENTAGE;
          commit('SET_TAX_PERCENTAGE', taxePercentage);
        }
      } catch (err) {
        throw new Error(err);
      }
    },

    async triggerIsMainOrderClosed({ commit }, { superOrderIdDms, email, dealerId }) {
      commit('SET_IS_MAIN_ORDER_CLOSED_STATUS', STATE_STATUSES.LOADING);

      try {
        const isClosed = await isMainOrderClosed(repository, {
          superOrderIdDms,
          email,
          dealerId,
        });

        commit('SET_IS_MAIN_ORDER_CLOSED', isClosed);
        commit('SET_IS_MAIN_ORDER_CLOSED_STATUS', STATE_STATUSES.SUCCESS);
      } catch {
        commit('SET_IS_MAIN_ORDER_CLOSED', false);
        commit('SET_IS_MAIN_ORDER_CLOSED_STATUS', STATE_STATUSES.ERROR);
      }
    },
  },
};
